const NotFound = () => (
    <div className="min-h-screen flex flex-col items-center justify-center">
        <h1 className="text-5xl font-bold">404</h1>
        <p className="text-xl mt-4">Page non trouvée</p>
        <a href="/" className="mt-6 text-primary-500 underline">Retour à l'accueil</a>
    </div>
);
export default NotFound;